import { render, staticRenderFns } from "./FavoritesModal.vue?vue&type=template&id=0eb985b9&"
import script from "./FavoritesModal.vue?vue&type=script&lang=js&"
export * from "./FavoritesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports